import { buildBindable } from '@monofe/di';
import { bindConfigAPI, injectConfigAPI, injectENV, TYPES, unbindConfigAPI } from '@monofe/util';
const DEFAULTS = {
  url: 'https://api.ats-workspace.com',
  auth: {
    clientId: 'MobileApplication.Test',
    clientSecret: 'secr3t!MobileApplication.Test',
    grantType: 'password',
    username: 'awdemo',
    password: '@Demo1'
  },
  extension: {
    auth: '/apptoken',
    siteData: '/sites/app.GetMyZipPatchSite',
    mediaDiff: '/media/app.CalculateMyMediaDifference',
    media: '/media(%MEDIAID%)/app.GetFile',
    mediaWithAccessToken: '/media(%MEDIAID%)/app.GetFile?access_token=%ACCESS_TOKEN%'
  }
};

function _build(container) {
  const env = injectENV(container);
  const config = {
    url: env.getString('REACT_APP_API_URL', DEFAULTS.url),
    auth: {
      clientId: env.getString('REACT_APP_API_AUTH_CLIENTID', DEFAULTS.auth.clientId),
      clientSecret: env.getString('REACT_APP_API_AUTH_CLIENTSECRET', DEFAULTS.auth.clientSecret),
      grantType: env.getString('REACT_APP_API_AUTH_GRANTTYPE', DEFAULTS.auth.grantType),
      username: env.getString('REACT_APP_API_AUTH_USERNAME', DEFAULTS.auth.username),
      password: env.getString('REACT_APP_API_AUTH_PASSWORD', DEFAULTS.auth.password)
    },
    extension: {
      auth: env.getString('REACT_APP_API_EXTENSION_AUTH', DEFAULTS.extension.auth),
      siteData: env.getString('REACT_APP_API_EXTENSION_SITEDATA', DEFAULTS.extension.siteData),
      mediaDiff: env.getString('REACT_APP_API_EXTENSION_MEDIADIFF', DEFAULTS.extension.mediaDiff),
      media: env.getString('REACT_APP_API_EXTENSION_MEDIA', DEFAULTS.extension.media),
      mediaWithAccessToken: env.getString('REACT_APP_API_EXTENSION_MEDIA_WITH_ACCESS_TOKEN', DEFAULTS.extension.mediaWithAccessToken)
    }
  };
  return Object.freeze(config);
}

export default buildBindable({
  id: TYPES.IConfigAPI,
  dependencies: [TYPES.IEnv],
  bind: bindConfigAPI,
  remove: unbindConfigAPI,
  inject: injectConfigAPI,
  build: container => Promise.resolve(_build(container))
});